import { render } from "./LoteFreteRA.vue?vue&type=template&id=202119a9&scoped=true"
import script from "./LoteFreteRA.vue?vue&type=script&lang=js"
export * from "./LoteFreteRA.vue?vue&type=script&lang=js"

import "./LoteFreteRA.vue?vue&type=style&index=0&id=202119a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202119a9"]])

export default __exports__